import React from "react"
import {
  HiUsers,
  HiOutlineDocumentText,
  HiOutlineBriefcase,
} from "react-icons/hi"
import "./FranchiseOfferings.css"

const offerings = [
  {
    icon: HiUsers,
    title: "High-Value Talent Acquisition",
    description:
      "Deliver specialized professionals across technology, operations, revenue, and leadership roles tailored to each client engagement.",
    highlight: "ROLES YOU CAN PLACE:",
    details:
      "Technology leaders, revenue operations, project managers, finance specialists, fractional executives, and more.",
  },
  {
    icon: HiOutlineDocumentText,
    title: "Legal & HR Compliance Guidance",
    description:
      "Provide employers with vetted contractors and employment solutions that come with compliant onboarding, payroll, and workforce policies.",
    highlight: "SUPPORT YOU'LL PROVIDE:",
    details:
      "Contractor agreements, payroll coordination, onboarding checklists, background screenings, and regulatory updates.",
  },
  {
    icon: HiOutlineBriefcase,
    title: "Strategic Workforce Partnerships",
    description:
      "Build long-term staffing relationships that help businesses scale with predictable capacity while maintaining lean internal teams.",
    highlight: "ENGAGEMENT MODELS:",
    details:
      "Contract, contract-to-hire, project-based teams, retained searches, and executive placements.",
  },
]

const FranchiseOfferings = () => {
  return (
    <section className='franchise-offerings section section-white'>
      <div className='container'>
        <div className='offerings-header animate-fade-up'>
          <h2 className='section-title'>
            What You&apos;ll Offer as a Franchise Owner
          </h2>
          <p className='section-subtitle'>
            Position your franchise as the go-to partner for specialized talent
            and workforce solutions in your market.
          </p>
        </div>

        <div className='offerings-grid'>
          {offerings.map((offering, index) => (
            <div
              key={offering.title}
              className='offering-card animate-fade-up'
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className='offering-icon'>
                <offering.icon />
              </div>
              <div className='offering-content'>
                <h3 className='offering-title'>{offering.title}</h3>
                <p className='offering-description'>{offering.description}</p>
                <div className='offering-highlight'>
                  <h4 className='highlight-title'>{offering.highlight}</h4>
                  <p className='highlight-details'>{offering.details}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default FranchiseOfferings

